/** Symbols / codes for manual cash payment entry and display (finance dashboard). */
export interface PaymentCurrencyOption {
  code: string;
  symbol: string;
  label: string;
}

export const PAYMENT_CURRENCY_OPTIONS: PaymentCurrencyOption[] = [
  { code: 'USD', symbol: '$', label: 'USD — US Dollar ($)' },
  { code: 'PKR', symbol: 'Rs', label: 'PKR — Pakistani Rupee (Rs)' },
  { code: 'EUR', symbol: '€', label: 'EUR — Euro (€)' },
  { code: 'GBP', symbol: '£', label: 'GBP — British Pound (£)' },
  { code: 'AED', symbol: 'د.إ', label: 'AED — UAE Dirham (د.إ)' },
  { code: 'SAR', symbol: '﷼', label: 'SAR — Saudi Riyal (﷼)' },
  { code: 'INR', symbol: '₹', label: 'INR — Indian Rupee (₹)' },
  { code: 'CAD', symbol: 'C$', label: 'CAD — Canadian Dollar (C$)' },
  { code: 'AUD', symbol: 'A$', label: 'AUD — Australian Dollar (A$)' },
  { code: 'TRY', symbol: '₺', label: 'TRY — Turkish Lira (₺)' },
  { code: 'CNY', symbol: '¥', label: 'CNY — Chinese Yuan (¥)' },
  { code: 'JPY', symbol: '¥', label: 'JPY — Japanese Yen (¥)' },
  { code: 'CHF', symbol: 'CHF', label: 'CHF — Swiss Franc' },
  { code: 'KWD', symbol: 'KD', label: 'KWD — Kuwaiti Dinar (KD)' },
  { code: 'QAR', symbol: 'QR', label: 'QAR — Qatari Riyal (QR)' },
  { code: 'BDT', symbol: '৳', label: 'BDT — Bangladeshi Taka (৳)' },
  { code: 'LKR', symbol: 'Rs', label: 'LKR — Sri Lankan Rupee (Rs)' },
  { code: 'OMR', symbol: 'OMR', label: 'OMR — Omani Rial' },
  { code: 'BHD', symbol: 'BD', label: 'BHD — Bahraini Dinar (BD)' },
  { code: 'MYR', symbol: 'RM', label: 'MYR — Malaysian Ringgit (RM)' },
];
// Kept in step with the API's BillingCurrencies (CryptoAPI/Services/Billing/BillingCatalog.cs): the CODE is the
// truth on the billing path, the symbol is for display. Match by code first (see currencyFor in Common/billing).

export function formatPaidAmount(amount: number, currencySymbol?: string | null): string {
  const sym = currencySymbol?.trim() || '$';
  const n = Number(amount);
  if (Number.isNaN(n)) return `${sym}0.00`;
  return `${sym}${n.toFixed(2)}`;
}
